<bz-button appBringozIdGenerator="dateRangePickerBtn"
           variant="tertiary"
           [disabled]="isDisabled"
           (clicked)="openCalendar($event)">
  <bz-icon class="margin-right-5" [icon]="icons.calendar"></bz-icon>
  <span class="br-body-2">{{ buttonDisplayName | translate }}</span>
</bz-button>